
import { defineComponent } from 'vue'
import MachinationsLightPage from '~/domain/pages/MachinationsLightPage'
import AboutContactForm from '~/components/about/AboutContactForm.vue'
import { PageData } from '~/domain/interfaces/PageDataTypes'
export default defineComponent({
  name: 'ContactPage',
  components: { AboutContactForm },
  extends: MachinationsLightPage,
  layout: 'machinations',
  head() {
    //@ts-ignore
    const pageHead = this.pageHead()
    const pageData = this.pageData as PageData
    const yoastDescription = pageData?.yoast_head_json?.description
    return {
      ...pageHead,
      title: `Contact`,
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          content: `Contact`,
        },
        {
          hid: 'description',
          name: 'description',
          content: yoastDescription,
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: yoastDescription,
        },
        ...pageHead?.meta,
      ],
    }
  },
  async asyncData(context) {
    const { store } = context

    const pageData = await store.dispatch('wp/fetchPageBySlug', {
      context,
      slug: 'contact',
    })
    store.commit('common/isBusy', false)
    await store.dispatch('common/setupPageLight', { context })
    return {
      pageData,
    }
  },
})
